import {
    Icon,
    IconButton,
} from '@mui/material';
import { MRT_ColumnDef } from 'material-react-table';
import { useEffect, useMemo, useState } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { TABLE_FILTER } from '../../../_const/tableFilter.const';
import { StandardTablePanel } from "../../../_components/panel/standardTable.panel";
import { removeSpaces } from '../../../_helpers/format.helper';
import { handleErrorResponse } from '../../../_helpers/handleResponse.helper';
import { ticketService } from '../../../_services/ticket.service';
import { CaseTicketsUplaodDrawer } from '../ticket-caseTicketsUplaodDrawer';
import { TicketCreateDrawer } from './ticket-createDrawer';
import { accountService } from '../../../_services/accounts.service';

export function TicketListPanel(params: { caseId: number }) {
    const [data, setData] = useState<any>({ items: [], count: 10 });
    const [filter, setFilter] = useState<any>({ ...TABLE_FILTER, order: "desc" });
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const [paymentDate, setPaymentDate] = useState<string>();

    const fetchData = async () => {
        setIsLoading(true);

        var _filter = { ...filter, caseId: params.caseId };

        return await ticketService.getAll(_filter)
            .then(
                json => {
                    setData(json);
                    console.log(json);
                }, handleErrorResponse)
            .finally(() => {
                setIsLoading(false);
            });
    };

    useEffect(() => {
        fetchData();
    }, [params.caseId, filter]);

    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [
            {
                id: 'actions',
                header: '',
                size: 20,
                enableSorting: false,
                enableColumnFilter: false,
                enableColumnActions: false,
                Cell: ({ row }) => (
                    <IconButton
                        color="primary"
                        onClick={() => { navigate(`/Case/${params.caseId}/Ticket/${row.original.id}/${removeSpaces(row.original.ticketType)}`) }}>
                        <Icon>visibility</Icon>
                    </IconButton>
                ),
            },

            {
                accessorKey: 'ticketReferenceNumber',
                header: 'Ticket',
                enableSorting: false,
                enableColumnActions: false,
                size: 20,


            },
            {
                accessorKey: 'subjectName',
                header: 'Subject',
                enableSorting: false,
                enableColumnActions: false,
                size: 20,
            },
            {
                accessorKey: 'ticketType',
                header: 'Type',
                enableSorting: false,
                enableColumnActions: false,
                size: 20,
            }
        ],
        []
    );

    return (
        <>
            <StandardTablePanel
                title="Case Tickets"
                buttons={(accountService.isAdmin || accountService.isUser) ? [
                    { icon: "add", onClick: () => { navigate("Create/Ticket") } },
                    { icon: "upload", onClick: () => { navigate(`Upload`) } }
                ] : []}
                columns={columns}
                data={data}
                filter={filter}
                setFilter={setFilter}
                loading={isLoading}
                enableBottomToolbar={true}
            />
            <Routes>
                <Route path="Create/Ticket" element={<TicketCreateDrawer setPaymentDate={setPaymentDate} onSave={() => { fetchData(); navigate(""); }} onClose={() => { navigate(""); }} />} />
                <Route path="Upload" element={<CaseTicketsUplaodDrawer onSave={() => { fetchData(); }} onClose={() => { navigate(""); }} />} />

            </Routes>

        </>
    );
}
